// The analytics vendors of the production site, as the snippets in index.html loaded them before: Google Ads
// (gtag) with its two conversion events, Microsoft Clarity, Mixpanel, Customer.io and Locus. Loaded only when
// analytics are enabled (src/config.js). Each vendor is set up on its own: one failing does not stop the others.
// The snippets are the vendors' own, made valid in a strict-mode module; their behavior is unchanged.

function loadScript(src, attributes = {}) {
  const script = document.createElement('script');
  script.async = true;
  script.src = src;
  for (const [name, value] of Object.entries(attributes)) script.setAttribute(name, value);
  const first = document.getElementsByTagName('script')[0];
  if (first?.parentNode) first.parentNode.insertBefore(script, first);
  else document.head.appendChild(script);
}

const GOOGLE_ADS_ID = 'AW-17516942025';

function googleAds() {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // gtag.js expects the arguments object itself
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GOOGLE_ADS_ID);
  loadScript(`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`);

  // conversion events: a submit button in a form with an e-mail (registration), and a registration form
  document.addEventListener('click', (e) => {
    const button = e.target.closest?.('[type="submit"]');
    const form = button?.closest('form');
    if (!form) return;
    const value = (id) => form.querySelector(`[id="${id}"]`)?.value ?? '';
    const email = value('email');
    if (email !== '') {
      window.gtag('set', 'user_data', { email });
      window.gtag('event', 'conversion', { send_to: GOOGLE_ADS_ID });
    }
    if (value('firstName') !== '' && value('lastName') !== '' && value('schoolName') !== '') {
      window.gtag('event', 'conversion', { send_to: `${GOOGLE_ADS_ID}/i6KJCM_FuLsbEMml3aBB` });
    }
  });
}

function clarity() {
  window.clarity =
    window.clarity ||
    function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
  loadScript('https://www.clarity.ms/tag/cbq6be7o7q');
}

// Mixpanel's loader snippet (2.x), with the variables it leaves undeclared declared
function mixpanelStub(b) {
  if (b.__SV) return;
  window.mixpanel = b;
  b._i = [];
  b.init = function (e, f, c) {
    function g(a, d) {
      const b = d.split('.');
      2 == b.length && ((a = a[b[0]]), (d = b[1]));
      a[d] = function () {
        a.push([d].concat(Array.prototype.slice.call(arguments, 0)));
      };
    }
    let a = b;
    'undefined' !== typeof c ? (a = b[c] = []) : (c = 'mixpanel');
    a.people = a.people || [];
    a.toString = function (a) {
      let d = 'mixpanel';
      'mixpanel' !== c && (d += '.' + c);
      a || (d += ' (stub)');
      return d;
    };
    a.people.toString = function () {
      return a.toString(1) + '.people (stub)';
    };
    const i =
      'disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove'.split(
        ' ',
      );
    for (let h = 0; h < i.length; h++) g(a, i[h]);
    const j = 'set set_once union unset remove delete'.split(' ');
    a.get_group = function () {
      function b(c) {
        d[c] = function () {
          const call2_args = arguments;
          const call2 = [c].concat(Array.prototype.slice.call(call2_args, 0));
          a.push([e, call2]);
        };
      }
      const d = {};
      const e = ['get_group'].concat(Array.prototype.slice.call(arguments, 0));
      for (let c = 0; c < j.length; c++) b(j[c]);
      return d;
    };
    b._i.push([e, f, c]);
  };
  b.__SV = 1.2;
  loadScript('https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js');
}

function mixpanel() {
  mixpanelStub(window.mixpanel || []);
  // anything other than the production domains reports to the development project
  const production = /(^teacher|^school)\.oksensay\.com/g;
  if (window.location.hostname.toLowerCase().match(production) === null) {
    window.mixpanel.init('e5c643f8228e69c15cbe3691794a6e49', { debug: true, ignore_dnt: true });
  } else {
    window.mixpanel.init('6ef7cdae2662767df1de7f5b01bf5dc0');
  }
  window.mixpanel.register({ Platform: 'Web' });
}

function customerIo() {
  const cio = (window._cio = window._cio || []);
  for (const name of ['load', 'identify', 'sidentify', 'track', 'page']) {
    cio[name] = function () {
      cio.push([name].concat(Array.prototype.slice.call(arguments, 0)));
    };
  }
  loadScript('https://assets.customer.io/assets/track.js', {
    id: 'cio-tracker',
    'data-site-id': '60e953f11d9a98c2d9d2',
    'data-use-array-params': 'true',
  });
}

function locus() {
  window.locus =
    window.locus ||
    function () {
      (window.locus.q = window.locus.q || []).push(arguments);
    };
  loadScript('https://prod.cdn.getlocus.ai/locus.min.js?id=glljyc');
}

/** Sets up every vendor; a vendor that fails is reported and skipped. */
export function loadAnalyticsVendors() {
  for (const vendor of [googleAds, clarity, mixpanel, customerIo, locus]) {
    try {
      vendor();
    } catch (error) {
      console.warn(`analytics vendor ${vendor.name} could not be set up`, error);
    }
  }
}
